module.exports = __webpack_public_path__ + "img/11.6a1ff3b3.jpg";